// Copyright (c) Bentley Systems
import * as React from "react";
import { SVGProps, useEffect, useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import { AnimatedIconProps } from "./AnimatedIconProps";

const BottomRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#67b01a"
        fillOpacity="60%"
        stroke="#fff"
        strokeOpacity="0.6"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(5 5)"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M12 18h7v14h-7V18zm2 2v2h3v-2h-3zm0 3v2h3v-2h-3zm0 3v2h3v-2h-3zm0 3v2h3v-2h-3z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M21 18h7v14h-7V18zm2 2v2h3v-2h-3zm0 3v2h3v-2h-3zm0 3v2h3v-2h-3zm0 3v2h3v-2h-3z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M12 15h16v2H12v-2zm0 17h16v2H12v-2z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M15 10l5 4h-10l5-4z"
       />
      <path
        transform="translate(5)"
        fill="#0E630A"
        d="M36.75 33.491v-2.996l-2.293-.469a7.91 7.91 0 00-.402-.937l1.306-1.958-2.109-2.11-1.958 1.306a5.907 5.907 0 00-.954-.418l-.469-2.276h-2.996l-.452 2.276a4.85 4.85 0 00-.954.418l-1.958-1.305-2.11 2.109 1.306 1.958c-.167.301-.3.62-.401.954l-2.293.469v2.979l2.293.469c.1.318.25.652.401.954l-1.305 1.958 2.109 2.109 1.975-1.306c.301.151.602.268.937.385l.469 2.31h2.996l.468-2.31c.302-.117.62-.234.921-.401l1.975 1.322 2.109-2.126-1.306-1.975c.151-.284.268-.619.385-.92l2.31-.469zm-8.385 1.674a3.19 3.19 0 01-3.18-3.18c0-1.758 1.439-3.197 3.18-3.197 1.74 0 3.197 1.44 3.197 3.197a3.182 3.182 0 01-3.197 3.18z"
       />
    </g>
  );
}

const TopRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#87cd1e"
        stroke="#83c444"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(0)"
       />
    </g>
  );
}

const ArchitectsManagementAnim = (props: AnimatedIconProps) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (props.isFocused !== undefined) {
      setToggle(props.isFocused);
    }
  }, [props.isFocused]);

  const rectangles = [
    <TopRectangle key="rectangle1" />,
    <BottomRectangle key="rectangle2" />,
  ];

  const springs = useSprings(
    rectangles.length,
    rectangles.map((el, index) => {
      return {
        transform: toggle
          ? `translate3d(0px, 0px, 0px)`
          : `translate3d(${index === 1 ? -5 : 5}px, 0px, 0px)`,
      };
    })
  );

  const animatedRectangles = springs.map((animatedStyle, index) => (
    <animated.g key={index} style={animatedStyle}>
      {rectangles[index]}
    </animated.g>
  ));

  return (
    <div
      onMouseOver={() => {
        if (props.isFocused === undefined) {
          setToggle(true);
        }
      }}
      onMouseOut={() => {
        if (props.isFocused === undefined) {
          setToggle(false);
        }
      }}
    >
      <svg
        style={{ height: "100%", width: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        viewBox="0 0 47 47"
      >
        {animatedRectangles}
      </svg>
    </div>
  );
};

export default ArchitectsManagementAnim;
